export default __webpack_public_path__ + "static/media/19.8da77232.svg";